const prodUrl = "https://prodback.connectifyz.com";
//@ts-ignore
const devUrl = "https://back.connectifyz.com";
export const baseUrl = import.meta.env.VITE_API_BASE_URL || prodUrl;

// Environment configuration
export const config = {
  apiBaseUrl: baseUrl,
  environment: import.meta.env.MODE,
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
};

export default config;
